<div class="chats-list-container">

  <h1>Ð§Ð°ÑÑ</h1>

  <form *ngIf="formGroup && !chatsService.buildingId" [formGroup]="formGroup">

    <div class="house-filter flex-space-between" *ngIf="servicedHousesList">
      <lib-dropdown [items]="parseServicedHousesList"
                    [multi]="true"
                    [formControlName]="'servicedHousesList'">
      </lib-dropdown>

      <lib-button *ngIf="!chatsService.userAdmin" [routerLink]="'/management-company/chats/create-message'">ÐÐ°Ð¿Ð¸ÑÐ°ÑÑ ÑÐ¾Ð¾Ð±ÑÐµÐ½Ð¸Ðµ</lib-button>
    </div>

  </form>

  <arm-serviced-houses-list
    [servicedHousesList]="chatsList"
    (activeElementEmit)="openItem($event)">
  </arm-serviced-houses-list>

  <arm-spinner *ngIf="loading" class="spinner"></arm-spinner>

</div>
